import InvoiceDetailPage from "layouts/shared/InvoiceDetailPage";

export default InvoiceDetailPage;
